<template>
  <div class="d-flex loading-container">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div class="loader-content">
      <span class="checking-data">{{ $t("common.checkingData") }}</span>
    </div>
  </div>
</template>

<script>
export default {
};
</script>
<style lang="scss" scoped>
.loading-container {
  position: absolute;
  top: 94px;
  inset-inline-start: -137px;
  background-color: white;
  align-items: center;
  border-radius: 50px;
  min-width: 271px;
  min-height: 85px;

  h6 {
    font-weight: 700;
    font-size: 16px;
    line-height: 152%;
    color: #000000;
    margin-bottom: 20px;
  }
  .checking-data {
    color: #000;
    font-size: 16px;
    font-weight: 700;
    line-height: 152%; /* 24.32px */
  }
  p {
    margin-top: 5px;
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    margin-bottom: 6px;
    line-height: 152%;
  }
}
.spinner-border {
  color: #103f5e;
  border-width: 0.35em;
  width: 38px;
  height: 38px;
  margin-inline-end: 22px;
  margin-inline-start: 31px;
  border-right-color: #d9d9d9;
}
</style>
